<main *ngIf="form">
    <div class="l-container l-container--m" *ngIf="currentSeite">
        <h1>{{ getDankesText() }}</h1>
        <h1 *ngIf="getGreeting()">{{ getGreeting() }}</h1>
    </div>
    <div class="l-container l-container--m" *ngIf="currentSeite">
        <text-element [element]="currentSeite.elemente[0]"></text-element>
    </div>

    <div class="l-container l-container--m" *ngIf="currentSeite">
        <h2>Die nächsten Schritte:</h2>

        <ul class="m-list m-list--big-ordered">
            <li>
                <div><strong>Bestätigung per E-Mail</strong><br>
                    Die wichtigsten Dokumente zu Ihrer Anfrage erhalten Sie von uns per E-Mail an
                    <strong>{{ getEmail() }}</strong>.
                </div>
            </li>
            <li>
                <div><strong>Persönliche Rückmeldung durch einen VHV-Baugeräte-Experten zu Ihrer Anfrage</strong> <br>
                    Wir bearbeiten Ihren Absicherungswunsch so schnell wie möglich und melden uns in den nächsten Tagen bei Ihnen.
                </div>
            </li>
        </ul>
    </div>

    <div class="l-container l-container--m">
        <button class="m-footer__next-button" type="button" (click)="onSubmit()">
            <span>Kopie Ihrer Anfrage herunterladen (PDF)</span>
        </button>
    </div>

    <div class="l-container l-container--m">
        <p class="h-spacer"> Sollten Sie Fragen oder Anregungen haben, können Sie uns unter folgender Nummer erreichen:</p>

        <ul class="m-list m-list--icon h-color-pri-dark">
            <li>
                <svg class="icon">
                    <use xlink:href="#icon-telephone"></use>
                </svg>
                <span>
          <a class="h-font-l" href="{{getStatischenText('KundenserviceTelefonnummerLink')}}"><strong>{{getStatischenText('KundenserviceTelefonnummer')}}</strong></a>
          <br>
          <span class="h-font-s">{{getStatischenText('KundenserviceOeffnungszeiten')}}</span>
        </span>
            </li>
        </ul>

        <a href="{{getBackToVHVUrl()}}" class="m-button m-button--full m-button--outline">
            Zurück zu VHV.de
        </a>
    </div>
</main>

